// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root___ulKD","buttons":"SendReceipts_buttons__21des","email":"SendReceipts_email__d3e6x","bookApptTitle":"SendReceipts_bookApptTitle__20Im6"};